export default __webpack_public_path__ + "static/media/post_it_for.6559eccb.png";